//import { GroupProps } from '@msdk/forms';
import { useTranslation } from '@msdk/common'
import { FieldType, FormGroupDefinition, FormNode } from '@msdk/definitions'
import { FieldProps } from '@msdk/forms'
import { styled } from '@msdk/ui'
import React, { ReactNode } from 'react'

import { ConditionalFormFieldRenderer } from './field-renderers'
interface GroupProps {
  node: FormNode
  children?: ReactNode[]
  config: Record<string, string>
}

const StyledCard = styled('div')`
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
`

const StyledHeader = styled('h1')`
  padding: 20px 24px;
  border-bottom: 2px solid #e5e7eb;
  font-size: 20px;
  margin: 0;
`

const StyledCardContent = styled('div')`
  padding: 16px 24px;
`

const StyledFields = styled('div')`
  display: flex;
  flex-direction: column;
`
const StyledFieldRow = styled('div', { shouldForwardProp: (prop) => prop !== '$borderTop' })<{
  $borderTop: boolean
}>`
  display: grid;
  grid-template-columns: 124px 1fr auto;
  align-items: center;
  gap: 16px;
  padding: 8px 12px;
  ${(props) => props.$borderTop && `border-top: 1px solid #e5e7eb;`}
`

const StyledFieldLabel = styled('div')`
  color: #4b5563;
  font-weight: 500;
`
const StyledFieldValue = styled('div')`
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
interface GroupNode {
  props: FieldProps
}

export function ReadonlyCardGroup(props: GroupProps) {
  const t = useTranslation()

  const groupDefinition = props.node.value.formDefinition as FormGroupDefinition
  const groupFields = props.children as GroupNode[]

  return (
    <StyledCard>
      {!groupDefinition.hideGroupHeader && (
        <StyledHeader>{t(groupDefinition.idml, groupDefinition.description)}</StyledHeader>
      )}
      <StyledCardContent>
        <StyledFields>
          {groupFields
            .filter((field) => field.props.node.value.visibility == 'Visible')
            .map((field, i) => (
              <StyledFieldRow key={i} $borderTop={i != 0}>
                <StyledFieldLabel>
                  {t(
                    field.props.node.value.fieldDefinition?.idml as string,
                    field.props.node.value.fieldDefinition?.description as string,
                  )}
                </StyledFieldLabel>
                <StyledFieldValue>
                  <ConditionalFormFieldRenderer
                    key={field.props.node.id}
                    node={field.props.node as FormNode}
                    fieldType={field.props.node.value.type as FieldType}
                  />
                </StyledFieldValue>
              </StyledFieldRow>
            ))}
        </StyledFields>
      </StyledCardContent>
    </StyledCard>
  )
}
